// note: keep these constants lowercase strings, to match the strings from the Backend
export const BULK_WORKFLOW_SHARE_ACTION = 'bulk_workflow_share'
export const CREATE_REMARK_ON_COMPANY_ACTION = 'create_remark_on_company'
export const CREATE_REMARK_ON_RECONCILIATION_TEXT_ACTION =
  'create_remark_on_reconciliation_text'
export const ARCHIVE_WORKFLOW_ACTION = 'archive_workflow'
export const LOCK_PERIOD_ACTION = 'lock_ledger'

export const CREATE_REMARK_ACTIONS = [
  CREATE_REMARK_ON_COMPANY_ACTION,
  CREATE_REMARK_ON_RECONCILIATION_TEXT_ACTION,
]

export const DOWNLOAD_AS_EXCEL_ACTION = 'downloadAsExcel'
export const CREATE_REMARK_ACTION = 'create_remark_action'
export const CONFIRM_NON_ACTIONABLE_COMPANIES_ACTION =
  'CONFIRM_NON_ACTIONABLE_COMPANIES_ACTION'
